import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["view", "form"];

  connect() {
  }

  switchToEditMode() {
    this.viewTarget.classList.add("u-hidden");
    this.formTarget.classList.remove("u-hidden");
  }

  switchToViewMode() {
    this.viewTarget.classList.remove("u-hidden");
    this.formTarget.classList.add("u-hidden");
  }
}
